/*
 * @Author: tao_yang
 * @Date: 2022-03-28 17:43:20
 * @LastEditors: tao_yang
 * @LastEditTime: 2022-12-23 11:30:21
 * @Description: 案例页入口
 */
import { useLocation } from 'react-router-dom';
import TemplateOne from '@/components/LandingPage/Template01';
import TemplateTwo from '@/components/LandingPage/Template02';

import './Example.scss';
export default function Example() {
    const location = useLocation();
    const key = new URLSearchParams(location.search).get('key');
    const contentMap = {
        0: <TemplateOne />,
        1: <TemplateTwo />,
    };
    return <div className="landing-example">{contentMap[key]}</div>;
}
